/// <reference types="vite/client" />

import { Client, Account, Teams } from 'appwrite';
import { bindImpersonationClient } from '../auth/impersonation';

export const client = new Client();

client
    .setEndpoint(import.meta.env.VITE_APPWRITE_URL)
    .setProject(import.meta.env.VITE_APPWRITE_PROJECT_ID)

if (import.meta.env.VITE_APPWRITE_DEV_KEY) {
    client.setDevKey(import.meta.env.VITE_APPWRITE_DEV_KEY);
}

// SDK 20 defaults to response format 1.8.0, which strips impersonation fields added in 1.9.
client.headers['X-Appwrite-Response-Format'] = '1.9.0';

bindImpersonationClient(client);

export const account = new Account(client);
export const teams = new Teams(client);
export { ID } from 'appwrite';
